import PropTypes from 'prop-types';
import { Icon } from '@codex/icons';

import { FilterLP, FilterContainerBody, SelectedHeader, SelectedHeaderBold } from '../styled';

export default function MobileFilterItem({ onFilterItemHeaderClick, label, children }) {
  return (
    <FilterContainerBody className={'dc-filter-container__body'}>
      <FilterLP className={'dc-filter-lp dc-filter--selected'} selected>
        <SelectedHeader // eslint-disable-line jsx-a11y/no-noninteractive-element-interactions
          className={'dc-filter--selected__header'}
          onClick={onFilterItemHeaderClick}
          onKeyPress={onFilterItemHeaderClick}
        >
          <Icon icon={'ChevronRight'} size={'large'} rotate={180} />
          <SelectedHeaderBold className={'dc-filter--selected__header--bold'}>
            Filter by:
          </SelectedHeaderBold>
          {label}
        </SelectedHeader>
        {children}
      </FilterLP>
    </FilterContainerBody>
  );
}

MobileFilterItem.propTypes = {
  children: PropTypes.element.isRequired,
  label: PropTypes.string.isRequired,
  onFilterItemHeaderClick: PropTypes.func
};

MobileFilterItem.defaultProps = {
  onFilterItemHeaderClick: () => {}
};
